import { createContext, useContext } from "react";
import { SelectOption } from "./types";

/**
 * Context for sharing select options across datagrid components.
 * Used by multiSelect/singleSelect columns to access available options
 * for rendering, editing, and filtering.
 */
export interface OptionsContextValue {
  options: Record<string, SelectOption[]>;
  getOptions: (field: string) => SelectOption[];
}

const defaultValue: OptionsContextValue = {
  options: {},
  getOptions: () => [],
};

export const OptionsContext = createContext<OptionsContextValue>(defaultValue);

/**
 * Hook to access options for a specific field
 */
export function useFieldOptions(field: string): SelectOption[] {
  const context = useContext(OptionsContext);
  return context.getOptions(field);
}

/**
 * Hook to access the full options context
 */
export function useOptionsContext(): OptionsContextValue {
  return useContext(OptionsContext);
}
